import BigNumber from "bignumber.js";

/**校验数字 */
export const validateNumber = (value: unknown) => {
    // 这里简单地示范一个检查是否为数字的例子
    if (typeof value === "number") {
        return true;
    } else if (typeof value === "string") {
        // 使用 parseInt() 或 parseFloat() 来验证字符串是否为数字
        return !isNaN(parseFloat(value));
    }
    // 如果 value 不是 string 或 number 类型，可以根据实际需求进行处理
    return false;
};

/** 手机号校验正则 */
export const phoneReg = /^1[3456789]\d{9}$/;

/** 银行卡号校验 */
export const isValidBankCard = (str: string) => {
    // 判断是否只包含数字且长度为8-30位
    if (!/^\d{8,30}$/.test(str)) {
        return false;
    }

    // Luhn算法校验
    let sum = 0;
    let shouldDouble = false;
    for (let i = str.length - 1; i >= 0; i--) {
        let digit = parseInt(str[i]);

        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) {
                digit -= 9;
            }
        }

        sum += digit;
        shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0;
};

/** 校验自定义表格数量/重量 */
export const validDiyTableNum = (value?: string | number) => {
    if (!value) return true;
    if (!new BigNumber(value).isLessThan(10000000)) {
        return "数量/重量需小于1000万";
    }
    if (!new BigNumber(value).isGreaterThan(0)) {
        return "数量/重量需大于0";
    }
    return true;
};

/** 校验自定义表格单价 */
export const validDiyTablePrice = (value?: string | number) => {
    if (new BigNumber(value!).isNaN()) return true;
    if (!new BigNumber(value!).isLessThan(100000000)) {
        return "单价需小于1亿";
    }
    if (!new BigNumber(value!).isGreaterThan(0)) {
        return "单价需大于0";
    }
    return true;
};
/**
 * JSON.stringify 会 忽略 null 或 undefined
 */
// 针对  是数字 的字段， 没有值 需要特殊处理即不传递给到后端
const numProps = [
    "unitPrice",
    "inboundWeight",
    "outboundWeight",
    "bookQuantity", // 盘点 - 账面数量
    "stocktakingQuantity", // 盘点 - 盘点数量
    "discWeight", // 盘点 - 盘重
    "grossWeight" // 盘点 - 毛重
];
export const dataToString = (_key: string, value: string | null | undefined) => {
    if (numProps.includes(_key) && !value) return undefined;
    return value ? value : "";
};

/**
 * 生成范围校验函数（支持整数/小数）
 * @param {Object} options 配置项
 * @param {number} [options.min] 最小值，包含最小值
 * @param {number} [options.max] 最大值， 包含最大值
 * @param {string} [options.message] 自定义错误提示（可选）
 * @returns {Function} validator 函数
 */
export const numRangeValidator = (
    { min, max, message } = {
        min: 0.01,
        max: 9999999999.99,
        message: "请输入大于0小于100亿的数字"
    }
) => {
    return (_rule: unknown, value: string | number, callback: (error?: Error) => void) => {
        // 不校验必填
        if (new BigNumber(value).isNaN()) {
            callback();
        } else {
            const minValue = new BigNumber(min).isNaN() ? 0.01 : min;
            const maxValue = new BigNumber(max).isNaN() ? 9999999999.99 : max;
            // 包含最小值，  最大值
            if (new BigNumber(value).isLessThan(minValue) || new BigNumber(value).isGreaterThan(maxValue)) {
                callback(new Error(message || "请输入大于0小于100亿的数字"));
            } else {
                callback();
            }
        }
    };
};
export const driverLicensePlatePattern =
    /((^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼])[A-Z]{1}[A-Z0-9]{5}[A-Z0-9挂学警港澳试超使领北南军海空外]{1}$)|(^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼])[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳试超使领北南军海空外]{1}$))/;

export const driverLicensePlateValidator = (_rule: unknown, value: string, callback: (error?: Error) => void) => {
    let newVal = value;
    console.log("driverLicensePlateValidator1--", newVal);
    if (value.includes("_")) {
        newVal = value.split("_")[0];
    }
    console.log("driverLicensePlateValidator2--", newVal);
    // 不校验必填
    if (driverLicensePlatePattern.test(newVal)) {
        callback();
    } else {
        callback(new Error("请输入正确的车牌号"));
    }
};
